import React from "react";
import { useTranslation } from "react-i18next";

const TabsComponent = ({
  items,
  tab,
  setTab,
  handleTabChange,
  separator = false,
}) => {
  const { i18n } = useTranslation();
  const handleChange = (value, name) => {
    if (handleTabChange) {
      handleTabChange(null, value);
    } else {
      setTab?.(value);
    }
  };

  // "CARD MANAGEMENT" reads "Card Management". A word with a digit in it is
  // a code ("3PL"), so it stays as written instead of becoming "3pl".
  // Other languages show the label as translated: French labels are written
  // in sentence case, and this title-casing breaks accented words
  // ("Approuvés" would read "ApprouvéS").
  const formatLabel = (value) => {
    if (!value) return "";
    if (i18n.resolvedLanguage && i18n.resolvedLanguage !== "en") return value;

    return value
      .replace(/_/g, " ")
      .replace(/\S+/g, (word) =>
        /\d/.test(word)
          ? word
          : word.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()),
      );
  };

  return (
    <div
      className={`w-full bg-ui-surface ${
        separator ? "border-b border-ui-border" : ""
      }`}
    >
      <div className="px-2 sm:px-3 lg:px-5">
        <nav className="flex h-10 items-end gap-1 overflow-x-auto scrollbar-hide whitespace-nowrap">
          {items.map(({ label, value, name }) => {
            const active = tab === value;

            return (
              <button
                key={value}
                type="button"
                name={name}
                onClick={() => handleChange(value, name)}
                className={`relative whitespace-nowrap rounded-md px-2 py-1.5 text-[13px] xl:text-sm font-medium transition-colors duration-200
                  ${
                    active
                      ? "bg-brand-light text-brand"
                      : "text-ui-text-muted hover:text-brand hover:bg-ui-surface-sunken"
                  }`}
              >
                {formatLabel(label)}

                {active && (
                  <span className="absolute bottom-0 left-2 right-2 h-0.5 rounded-full bg-brand" />
                )}
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default TabsComponent;
